export default __webpack_public_path__ + "static/media/box4.fd00cbc9.jpg";